import React from "react";
import classnames from "classnames";
import { useSnapshot } from "valtio";
import { useTranslation } from "react-i18next/";
import { StyledButton } from "@aureskonnect/react-ui";

import {
    store,
    setCashManagements,
    setSelectedPeripherals,
    setCheckModificationEffect,
} from "../store";
import { store as useStore } from "../../PeripheralConfigure/MoneticPeripheralConfigure/store";
import { getAuthorizationStates } from "@components/VerticalLayout/StyledSidebarMenu";

import "../index.css";
import { useSelector } from "react-redux";
import { PERIPHERAL_TYPE_CASH_MANAGEMENT } from "@constants/index";
import { ID_COINERS } from "@constants/menu";

export default function CashManagementActionColumn({
    rowData,
    element,
    isDataCashManagementUpdated,
    selectedRows,
}: any) {
    const { t } = useTranslation();
    const { cashManagements } = useSnapshot(store);
    const { dataTable } = useSnapshot(useStore);
    const [isSelected, setIsSelected] = React.useState<boolean>(false);
    const authorizationList = useSelector(
        (state: any) => state.global.infoUser.profileAuthorization
    );
    React.useEffect(() => {
        const validSelectedRows = selectedRows.filter(
            (elt: any) => elt[t("Application")] !== ""
        );

        if (validSelectedRows.length > 1) {
            setCashManagements({});
            setIsSelected(false);
            return;
        }

        const sourceSubRows =
            validSelectedRows.length === 1
                ? validSelectedRows[0].subRows
                : rowData?.subRows;

        if (sourceSubRows !== undefined) {
            sourceSubRows.forEach((el: any) => {
                if (
                    element.Id === el.peripheralId ||
                    cashManagements.some((item) => item.Id === element.Id)
                ) {
                    const alreadyExists = cashManagements.some(
                        (item) => item.Id === element.Id
                    );
                    if (!alreadyExists) {
                        setCashManagements(element);
                    }
                    setIsSelected(true);
                }
            });
        }
        // eslint-disable-next-line
    }, [rowData, isDataCashManagementUpdated]);

    function isSelectedCashManagment() {
        let isSelectedmonetics: any[] = [];
        dataTable.forEach((element: any) => {
            if (
                selectedRows.length !== 0 &&
                selectedRows.filter((elt: any) => elt[t("Application")] !== "")
                    .length === 1
            ) {
                if (
                    selectedRows.filter(
                        (elt: any) => elt[t("Application")] !== ""
                    )[0].shopId === element.shopId
                ) {
                    for (let el of element.subRows) {
                        if (el?.subRows !== undefined) {
                            for (let row of el.subRows) {
                                if (
                                    row.peripheralType ===
                                    PERIPHERAL_TYPE_CASH_MANAGEMENT
                                ) {
                                    if (
                                        !cashManagements.some(
                                            (item) =>
                                                item.Id === row.peripheralId
                                        )
                                    ) {
                                        isSelectedmonetics.push(row);
                                    }
                                }
                            }
                        }
                    }
                }
            } else if (rowData.shopId === element.shopId) {
                for (let el of element.subRows) {
                    if (el?.subRows !== undefined) {
                        for (let row of el.subRows) {
                            if (
                                row.peripheralType ===
                                PERIPHERAL_TYPE_CASH_MANAGEMENT
                            ) {
                                if (
                                    !cashManagements.some(
                                        (item) => item.Id === row.peripheralId
                                    )
                                ) {
                                    isSelectedmonetics.push(row);
                                }
                            }
                        }
                    }
                }
            }
        });
        return isSelectedmonetics;
    }
    const cashManagmentList: any[] = isSelectedCashManagment();
    const modify = getAuthorizationStates(ID_COINERS, authorizationList)
        .Modifie;

    const peripheriesAlreadyExistInApp =
        rowData?.subRows?.find(
            (row: any) => row.peripheralType === PERIPHERAL_TYPE_CASH_MANAGEMENT
        );

    const isCurrentSelected = cashManagements.some(
        (item) => item.Id === element.Id
    );
    const isElementMissing =
        cashManagements.length === 1 && !isCurrentSelected;
    const isAlreadyAssociatedElsewhere = cashManagmentList.some(
        (item) => item.peripheralId === element.Id
    );
    const isCurrentAppAssociated =
        peripheriesAlreadyExistInApp?.peripheralId === element.Id;
    const isPeripheralAlreadyUsed =
        isAlreadyAssociatedElsewhere && !isCurrentAppAssociated;

    const isNonModify = modify === false;

    const hasMultipleSelectedApplications =
        selectedRows.filter((elt: any) => elt[t("Application")] !== "").length >
        1;

    const isDisabled =
        isElementMissing ||
        isPeripheralAlreadyUsed ||
        isNonModify ||
        hasMultipleSelectedApplications;

    return (
        <StyledButton
            rounded
            outline
            variant={isCurrentSelected ? "danger" : "light"}
            className={`${classnames(
                "button-style-select___clz afa_btn_selectPeripheral",
                { "not-allowed-icon__clz": isDisabled }
            )}`}
            onClick={() => {
                if (isDisabled) return;
                setCashManagements(element);
                setSelectedPeripherals(element);
                setIsSelected(!isSelected);
                setCheckModificationEffect(true);
            }}
        >
            <span>{isCurrentSelected ? t("Deselect") : t("Select")}</span>
        </StyledButton>
    );
}
